import ContactForm from "@/components/contact/ContactForm";
import ContactInfo from "@/components/contact/ContactInfo";
import { Helmet } from "react-helmet";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Karinfinity</title>
        <meta 
          name="description" 
          content="Get in touch with Karinfinity to discuss your data analytics and AI consulting needs." 
        />
      </Helmet>
      
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <h1 className="text-3xl md:text-4xl font-bold mb-4">Get in Touch</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Ready to transform your data strategy? Contact us to discuss how we can help.
              </p>
            </div>
            
            <div className="flex flex-col md:flex-row bg-white rounded-lg shadow-lg overflow-hidden">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
